import React from 'react';
import { Typography } from 'views/components/atoms/Typography';
import { Color, FontSize } from 'views/constants';
import { BaseLink } from 'views/components/atoms/BaseLink';

type LinkTextProps = {
  to: string;
  size?: FontSize;
  anotherTab?: boolean;
  onClick?(): void;
};

export const LinkText: React.FC<LinkTextProps> = ({
  to,
  size,
  anotherTab,
  onClick,
  children,
}) => (
  <BaseLink to={to} anotherTab={anotherTab} onClick={onClick}>
    <Typography color={Color.C7} size={size}>
      {children}
    </Typography>
  </BaseLink>
);
